import React, { Component } from 'react'
import VideoPlayer from "../Helper/VideoPlayer"
import refresh from '../../assets/images/icons/refresh.png'
import switcharrow from '../../assets/images/icons/switch-arrow.png'


export default class Nystagmus extends Component {
  render() {
      const {onClick} = this.props;
    return (
        <div>
          <div className="check mt-3">
              <div className="row">
                <div className="col-lg-6">
                  <h2>All right, let’s check for any involuntary eye movements.</h2>

                  <p>
                    Constant dizziness is often caused by problems with the inner ear, or vestibular system, which can cause certain eye movements.
                  </p>
                  <p>
                    Watch the video to see how to check for these eye movements and what to look for. Then, select the option that best describes what you saw.
                  </p>
                </div>
                <div className="offset-lg-1 col-lg-5">
                    <VideoPlayer src="https://www.youtube.com/embed/VolVn8SqYoY" thumbnail='Look for Nystagmus - 5.jpg' width="300"/>
                </div>
              </div>
              
              <div className="row mt-2">
                <div className="col-lg-4">
                  <button className="btn btn-secondary w-100 p-2H text-left"  onClick={onClick.bind(this,16,false)}>
                    
                    <div className="float-left">Horizontal</div>
                    <img alt="switch-arrow" className="float-right" src={switcharrow} width="35"/>
                    </button>
                </div>
               
                <div className="col-lg-4">
                  <button className="btn btn-dark w-100 p-2 text-left"  onClick={onClick.bind(this,17,true)}>
                    <div className="float-left">A Different <span className="sub-text">Eye Movement</span> </div>
                    <img alt="refresh"  className="float-right" src={refresh}  width="30"/>
                  </button>
                </div>
                
                <div className="col-lg-4">
                  <button className="btn btn-info w-100 p-2 text-left"  onClick={onClick.bind(this,10,false)}>
                  <div className="float-left"><div>No Eye <span className="sub-text">Movement</span> </div></div>
                    <i className="fa fa-ban float-right t-30"></i></button>
                </div>
              </div>
          </div>
         
        </div>

    )
  }
}
